// import { Nullable } from 'types';
import { TokenResponse } from 'services/api/responses/responseTypes';

export default class Token {
  accessToken: string;

  refreshToken: string;

  tokenType: string;

  scope: Array<string> | null | undefined;

  expiresIn: number;

  constructor(data: TokenResponse) {
    this.accessToken = data.access_token;
    this.refreshToken = data.refresh_token;
    this.tokenType = data.token_type;
    this.scope = data.scope;
    this.expiresIn = data.expires_in;
  }
}
